import React, { useState } from "react";
import HeroBanner from "../components/HeroBanner";
import Contactbanner from "../assets/images/Contactbanner.png";
import "../../src/components/ContactForm.css";

function ContactUsPage() {
  const bannerimg = Contactbanner;
  const tittle = "Contact Us";
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validation
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    if (!name || !email) {
      alert("Please enter all required fields.");
      return;
    }

    if (!emailPattern.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    try {
      const response = await fetch(
        "https://realtybase.sharecapacity.com/user/email",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name,
            email,
            message,
          }),
        }
      );

      const responseData = await response.json();
      //console.log(responseData.message, "check");
      alert(responseData.message);

      // Clear form fields by resetting state
      setName("");
      setEmail("");
      setMessage("");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  return (
    <div>
      <HeroBanner bannerimg={bannerimg} tittle={tittle} />
      <div className="ContactForm">
        <div className="container  py-5">
          <div className="row d-flex flex-column justify-content-center align-items-center">
            <div className="col-md-8 d-flex justify-content-center ">
              <div className="text-center">
                <h1 className="font-face-PlusJakartaSans-Bold">
                  Send Your Message
                </h1>
                <h4 className="mt-3 font-face-PlusJakartaSans-Regular">
                  support@realtybase.com
                </h4>
              </div>
            </div>
            <div className="col-md-8 mt-5">
              <form
                className="d-flex flex-column gap-3 w-100"
                onSubmit={handleSubmit}
                id="myForm"
              >
                <input
                  placeholder="Full Name"
                  id="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  placeholder="Email Address"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="text"
                />{" "}
                <textarea
                  rows={6}
                  placeholder="Message"
                  id="message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
                <div className="text-center">
                  <button type="submit">Send Message</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUsPage;
